export const TABLE_HEADER_ROWS = [
  'Name',
  'Due',
  'Overall Status',
  'Tasks Submitted',
  'Tasks Complete'
];
